import { API } from 'aws-amplify';
import axios from 'axios';

import { withCorrelationRetry, withInitHeaders } from '../api/correlationIdInitiated';
import { getLocalHeaders } from '../api/makeAjaxRequest';
import config from './aws';

export class ApiCallDispatcher {
    config = [];

    configure(conf) {
        this.config = conf;
    }

    async post(api, path, data) {
        let endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        let isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        if (isLocal) {
            return withCorrelationRetry(endpointConf.endpoint, async (initiated) => {
                const response = await axios.post(endpointConf.endpoint + path, data, {
                    headers: { ...(await getLocalHeaders()), ...initiated },
                });
                return response.data;
            });
        } else {
            return withCorrelationRetry(endpointConf.endpoint, (initiated) =>
                API.post(api, path, withInitHeaders({ body: data }, initiated))
            );
        }
    }

    async get(api, path, args = '') {
        const endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        const isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        const fullPath = args ? `${path}?${args}` : path;
        if (isLocal) {
            return withCorrelationRetry(
                endpointConf.endpoint,
                async (initiated) => {
                    const response = await axios.get(endpointConf.endpoint + fullPath, {
                        headers: { ...(await getLocalHeaders()), ...initiated },
                    });
                    return response.data;
                },
                { canRetry: true }
            );
        } else {
            return withCorrelationRetry(
                endpointConf.endpoint,
                (initiated) => API.get(api, fullPath, withInitHeaders({}, initiated)),
                { canRetry: true }
            );
        }
    }

    async put(api, path, data) {
        let endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        let isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        if (isLocal) {
            return withCorrelationRetry(endpointConf.endpoint, async (initiated) => {
                const response = await axios.put(endpointConf.endpoint + path, data, {
                    headers: { ...(await getLocalHeaders()), ...initiated },
                });
                return response.data;
            });
        } else {
            return withCorrelationRetry(endpointConf.endpoint, (initiated) =>
                API.put(api, path, withInitHeaders({ body: data }, initiated))
            );
        }
    }

    async del(api, path) {
        let endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        let isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        if (isLocal) {
            return withCorrelationRetry(endpointConf.endpoint, async (initiated) => {
                const response = await axios.delete(endpointConf.endpoint + path, {
                    headers: { ...(await getLocalHeaders()), ...initiated },
                });
                return response.data;
            });
        } else {
            return withCorrelationRetry(endpointConf.endpoint, (initiated) =>
                API.del(api, path, withInitHeaders({}, initiated))
            );
        }
    }
}

const ApiDispatcher = () => {
    const conf = config;
    const dispatcher = new ApiCallDispatcher();
    dispatcher.configure(conf);
    return dispatcher;
};
export const Api = ApiDispatcher();
